import { fetchApi } from "@modules/news/api"
import { rerenderTrafficStarsBeforePagination } from "@modules/news/traffic-stars.ts"
import { dispatchGlobalEvent } from "@modules/util/events"
import { LogLevel, log } from "@modules/util/logger"
import { advertNewsCardsContainerElement } from "../../global/dom.ts"
import { afterApiFetched } from "../after-api-fetched.ts"
import {
    disableAllPaginationElements,
    getNextPage,
    getPage,
    getPreviousPageToLoad,
    setNextPage,
    setPage,
    setPreviousPage,
} from "../pagination/pagination"
import { rerenderSoladsBeforePagination } from "../solads"

export async function onPaginationButtonClick(element: HTMLElement | null, clickFunction: () => Promise<void>) {
    element?.setAttribute("loading", "")
    disableAllPaginationElements()
    try {
        await clickFunction()
    } catch (e: any) {
        log(LogLevel.ERROR, e)
    }

    element?.removeAttribute("loading")
}

export async function onPreviousClickPc() {
    setPage(getPage() - 1)
    await afterApiFetched(await fetchApi())
    rerenderSoladsBeforePagination()
    rerenderTrafficStarsBeforePagination()

    dispatchGlobalEvent("news.pagination.change", {
        page: getPage(),
    })
}

export async function onPreviousClickMobile() {
    setPage(getPreviousPageToLoad())
    setPreviousPage(getPreviousPageToLoad() - 1)

    const firstCardElement = advertNewsCardsContainerElement()?.querySelector(".news-anzeige")
    await afterApiFetched(await fetchApi(), {
        insertAdjacentHTML: "afterbegin",
    })
    firstCardElement?.scrollIntoView()
    rerenderSoladsBeforePagination()
    rerenderTrafficStarsBeforePagination()

    dispatchGlobalEvent("news.pagination.change", {
        page: getPage(),
    })
}

export async function onNextClickPc() {
    setPage(getPage() + 1)
    await afterApiFetched(await fetchApi())
    rerenderSoladsBeforePagination()
    rerenderTrafficStarsBeforePagination()

    dispatchGlobalEvent("news.pagination.change", {
        page: getPage(),
    })
}

export async function onNextClickMobile() {
    setPage(getNextPage())
    setNextPage(getNextPage() + 1)

    await afterApiFetched(await fetchApi(), {
        insertAdjacentHTML: "beforeend",
    })
    rerenderSoladsBeforePagination()
    rerenderTrafficStarsBeforePagination()

    dispatchGlobalEvent("news.pagination.change", {
        page: getPage(),
    })
}
